import { Component } from 'react';
import Loading from '../../../components/Loading';

import { COLUMNS } from './keys';
import { linReg } from '../../../lib/reduce';
import CheckData from '../../../components/CatchError';
import DataTable from '../../../components/Datatable';
import { scrollForTable } from '../../../components/Datatable/utils';

class Table extends Component {
    constructor() {
        super();
        this.offsetStep = 100;
        this.defaultCount = 5;
    }

    render() {
        if (this.props.loading && !this.props.isLoadMore) {
            return <Loading padding={10} />;
        }

        const attr = {
            query: this.props.query,
            offsetStep: this.offsetStep,
            domain: this.props.domain,
        };

        const sumImpressions = this.props.allData.reduce((acc, curr) => {
            acc += curr.impressions;
            return acc;
        }, 0);

        const avgImpressions = sumImpressions / this.props.allData.length;
        const filteredData = this.props.getData(this.props.allData, avgImpressions);

        const showLoadMoreBtn = this.props.data?.length === this.offsetStep;

        const sortFns = {
            attr_imp: (array) =>
                array.sort((a, b) => {
                    let a_imp = linReg(a.impressionsL);
                    let b_imp = linReg(b.impressionsL);
                    return a_imp.slope - b_imp.slope;
                }),
            name: (array) => array.sort((a, b) => a.name.localeCompare(b.name)),
            type: (array) => array.sort((a, b) => a.type.localeCompare(b.type)),
            pages: (array) => array.sort((a, b) => a.pages - b.pages),
            action: (array) => array.sort((a, b) => a.salience - b.salience),
            impressionsL: (array) => array.sort((a, b) => a.impressions - b.impressions),
            impressions_per_page: (array) =>
                array.sort((a, b) => a.impressions / a.pages - b.impressions / b.pages),
            ctr: (array) => array.sort((a, b) => a.ctr - b.ctr),
        };

        return (
            <>
                <CheckData
                    content_id={this.props.content_id}
                    parent_id={this.props.parent_id}
                    data={filteredData}
                    loading={this.props.loading}
                    loadMore={this.props.isLoadMore}
                >
                    <DataTable
                        nodes={filteredData}
                        sortFns={sortFns}
                        COLUMNS={COLUMNS}
                        fileName="Entities"
                        defaultSize={this.defaultCount}
                        forceRun={this.props.forceRun}
                        header={this.props.header}
                        extraBtns={this.props.extraBtns}
                        defaultSortKey="impressions"
                        customEmptyMessage="There is no data"
                        showLoadMoreBtn={showLoadMoreBtn}
                        loadMoreLoading={this.props.isLoadMore}
                        loadMore={() => this.props.loadMore(attr)}
                        additionalStyles={{
                            Table: `
                                --data-table-library_grid-template-columns :  minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important;
                               ${scrollForTable}
                            `,
                            BaseCell: `  font-family: 'Raleway';
                                        font-weight: 500;
                                        font-size: 16px;
                                        line-height: 19px;
                                        padding: 16px 10px;
                                        color: #0D182C;
                                    
                                    
                                        &.underline {
                                        text-decoration: underline;
                                        }`,
                        }}
                    />
                </CheckData>
            </>
        );
    }
}

export default Table;
